import { render, staticRenderFns } from "./GroupAssignement.vue?vue&type=template&id=9a34631a&scoped=true"
import script from "./GroupAssignement.vue?vue&type=script&lang=js"
export * from "./GroupAssignement.vue?vue&type=script&lang=js"
import style0 from "./GroupAssignement.vue?vue&type=style&index=0&id=9a34631a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a34631a",
  null
  
)

export default component.exports